import { ChevronLeft, ChevronRight } from 'lucide-react';

import { cn } from '../../../lib/utils';
import { Button } from '../Button';
import { monthLabel } from './helpers';
import type { MonthStepperProps } from './types';

export function MonthStepper({ month, onShift, className }: MonthStepperProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Button variant="ghost" size="sm" onClick={() => onShift(-1)} aria-label="Previous month">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="min-w-32 text-center text-sm font-medium text-foreground">
        {monthLabel(month)}
      </span>
      <Button variant="ghost" size="sm" onClick={() => onShift(1)} aria-label="Next month">
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
